import { render, staticRenderFns } from "./ConfiguratorPrices.vue?vue&type=template&id=9659cb80&scoped=true"
import script from "./ConfiguratorPrices.vue?vue&type=script&lang=js"
export * from "./ConfiguratorPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9659cb80",
  null
  
)

export default component.exports